{
  "home": {
    "title": "Tashkilotlar",
    "add": "Tashkilot qo'shish",
    "search": "Qidirish",
    "tableLabel": "Tashkilotlar jadvali",
    "empty": "Tashkilotlar mavjud emas",
    "emptyHint": "Birinchi tashkilotni qo'shing — keyin unga suv omborlari va adminlar biriktiriladi.",
    "noResults": "Hech narsa topilmadi",
    "clear": "Tozalash",
    "loadError": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish"
  },
  "columns": {
    "organization": "Tashkilot",
    "slug": "Identifikator",
    "tenants": "Suv omborlari",
    "createdAt": "Yaratilgan",
    "actions": "Harakat",
    "reservoir": "Suv ombori",
    "kind": "Turi",
    "location": "Joylashuv",
    "siteId": "Unified server ID",
    "members": "Xodimlar",
    "admin": "Admin",
    "login": "Login",
    "position": "Lavozim",
    "phone": "Telefon"
  },
  "actions": {
    "open": "Ochish",
    "edit": "Tahrirlash",
    "delete": "O'chirish",
    "addAdmin": "Admin qo'shish",
    "openReservoir": "Suv omboriga o'tish",
    "remove": "Olib tashlash",
    "rowMenu": "Amallar",
    "editOrganization": "Tashkilotni tahrirlash"
  },
  "org": {
    "subtabs": "Tashkilot bo'limlari",
    "tenantsTab": "Suv omborlari",
    "adminsTab": "Tashkilot adminlari",
    "addTenant": "Suv ombori qo'shish",
    "addAdmin": "Admin qo'shish",
    "tenantsLabel": "Suv omborlari jadvali",
    "adminsLabel": "Tashkilot adminlari jadvali",
    "noTenants": "Suv omborlari mavjud emas",
    "noTenantsHint": "Tashkilotga birinchi suv omborini qo'shing.",
    "noAdmins": "Adminlar mavjud emas",
    "noAdminsHint": "Tashkilot adminini qo'shing — u barcha suv omborlarini boshqaradi.",
    "notFound": "Tashkilot topilmadi",
    "notFoundHint": "Tashkilot o'chirilgan yoki unga kirish huquqingiz yo'q.",
    "you": "Siz"
  },
  "kinds": {
    "reservoir": "Suv ombori",
    "hydro_plant": "GES",
    "canal": "Kanal",
    "pump_station": "Nasos stansiyasi",
    "other": "Boshqa"
  },
  "orgPanel": {
    "createTitle": "Tashkilot qo'shish",
    "name": "Nomi",
    "namePlaceholder": "Masalan: O'zbekgidroenergo",
    "slug": "Identifikator",
    "slugHint": "Manzilda ishlatiladi: faqat kichik lotin harflari, raqamlar va \"-\"",
    "slugLocked": "Identifikatorni faqat asosiy admin o'zgartira oladi",
    "description": "Tavsif",
    "descriptionPlaceholder": "Tashkilot haqida qisqacha",
    "danger": "Xavfli zona",
    "delete": "Tashkilotni o'chirish",
    "deleteHint": "Tashkilot va uning barcha suv omborlari o'chiriladi.",
    "confirmDelete": {
      "title": "Tashkilotni o'chirish",
      "text": "«{{name}}» va uning {{count}} ta suv ombori o'chiriladi. Bu amalni ortga qaytarib bo'lmaydi.",
      "confirm": "O'chirish"
    }
  },
  "tenantPanel": {
    "createTitle": "Suv ombori qo'shish",
    "name": "Nomi",
    "namePlaceholder": "Masalan: Chotqol suv ombori",
    "slug": "Identifikator",
    "slugHint": "Manzilda ishlatiladi: /t/identifikator",
    "kind": "Turi",
    "description": "Tavsif",
    "descriptionPlaceholder": "Obyekt haqida qisqacha",
    "location": "Joylashuv",
    "lat": "Kenglik",
    "lng": "Uzunlik",
    "latPlaceholder": "41.6512",
    "lngPlaceholder": "70.0261",
    "siteId": "Unified server sayt ID",
    "siteIdPlaceholder": "Masalan: chotqol-01",
    "siteIdHint": "ATNT yagona serveridagi obyekt identifikatori (jonli ma'lumotlar uchun)",
    "admins": "Adminlar",
    "noAdmins": "Hali admin biriktirilmagan",
    "addAdmin": "Admin qo'shish",
    "removeAdmin": "{{name}} — olib tashlash",
    "danger": "Xavfli zona",
    "delete": "Suv omborini o'chirish",
    "deleteHint": "Suv ombori, uning sahifalari va qurilmalari o'chiriladi.",
    "confirmDelete": {
      "title": "Suv omborini o'chirish",
      "text": "«{{name}}» o'chiriladi. Bu amalni ortga qaytarib bo'lmaydi.",
      "confirm": "O'chirish"
    },
    "confirmRemoveAdmin": {
      "title": "Adminni olib tashlash",
      "text": "«{{name}}» «{{tenant}}» suv omboridan olib tashlanadi.",
      "confirm": "Olib tashlash"
    }
  },
  "adminPanel": {
    "orgTitle": "Tashkilot admini qo'shish",
    "tenantTitle": "Suv ombori admini qo'shish",
    "orgCaption": "Tashkilot: {{name}}",
    "tenantCaption": "Suv ombori: {{name}}",
    "orgNote": "Tashkilot admini tashkilotning barcha suv omborlarini va ularning adminlarini boshqaradi.",
    "tenantNote": "Suv ombori admini shu suv omborining barcha bo'limlariga to'liq huquqqa ega.",
    "confirmRemove": {
      "title": "Adminni olib tashlash",
      "text": "«{{name}}» tashkilot adminlari ro'yxatidan olib tashlanadi.",
      "confirm": "Olib tashlash"
    }
  },
  "form": {
    "fullName": "F.I.SH",
    "fullNamePlaceholder": "Ism Familiya",
    "position": "Lavozim",
    "positionPlaceholder": "Masalan: Bosh dispetcher",
    "phone": "Telefon",
    "phonePlaceholder": "+998 90 123 45 67",
    "active": "Faol",
    "save": "Saqlash",
    "cancel": "Bekor qilish",
    "backLink": "Ortga qaytish"
  },
  "validation": {
    "required": "Bo’sh maydonni to’ldiring",
    "min": "Kamida {{count}} ta belgi kiriting",
    "max": "Ko'pi bilan {{count}} ta belgi",
    "slug": "Faqat kichik lotin harflari, raqamlar va \"-\"",
    "lat": "Kenglik -90 dan 90 gacha bo'lishi kerak",
    "lng": "Uzunlik -180 dan 180 gacha bo'lishi kerak",
    "login": "Faqat lotin harflari, raqamlar va . _ -",
    "phone": "Telefon raqami noto'g'ri"
  },
  "toast": {
    "orgCreated": "Tashkilot qo'shildi",
    "orgSaved": "Tashkilot saqlandi",
    "orgDeleted": "Tashkilot o'chirildi",
    "tenantCreated": "Suv ombori qo'shildi",
    "tenantSaved": "Suv ombori saqlandi",
    "tenantDeleted": "Suv ombori o'chirildi",
    "adminCreated": "Admin qo'shildi",
    "adminRemoved": "Admin olib tashlandi",
    "noChanges": "O'zgartirish kiritilmagan",
    "error": "Xatolik yuz berdi"
  }
}
